import { visuallyHidden } from "@mui/utils";
import { PREDICAMENT_STATE_YES } from "core/consts";
import { HorizontalLayout, VerticalLayout } from "ds_legacy/materials/layouts";
import { margin, padding, sizing } from "ds_legacy/materials/metrics";
import {
  DatePickerWithLabel,
  LARGE_INPUT_WIDTH,
  PatientFormSubheading,
  Section,
  SMALL_INPUT_MIN_WIDTH,
  TextInputWithLabel,
  YesNoRadioWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionEleven = () => {
  const translations = useTranslations();

  return (
    <Section title={translations.patientForms.drvGeneralForm.sectionTen.title}>
      <PatientFormSubheading style={{ padding: padding(0, 0, 1) }}>
        {translations.patientForms.drvGeneralForm.sectionTen.pensionInformation}
      </PatientFormSubheading>
      <YesNoRadioWithLabel
        elementName="special_payments_from_civil_services"
        formLabelSx={visuallyHidden}
        label={
          translations.patientForms.drvGeneralForm.sectionTen.pensionInformation
        }
        startWithNo
      />
      <PatientFormSubheading>
        {translations.patientForms.drvGeneralForm.sectionTen.pensionBenefits}
      </PatientFormSubheading>
      <YesNoRadioWithLabel
        elementName="retirement_pension_received_applicable"
        label={
          translations.patientForms.drvGeneralForm.sectionTen.penisonApplication
        }
        sideMutation={(_value, mutate) => {
          mutate(null, "retirement_pension_received");
        }}
        startWithNo
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <TextInputWithLabel
              elementName="retirement_pension_received"
              flatModel
              inputProps={{
                style: { minWidth: SMALL_INPUT_MIN_WIDTH, width: "100%" },
              }}
              label={
                translations.patientForms.drvGeneralForm.sectionTen
                  .namePensionInsurance
              }
              labelWrapperSx={{ width: LARGE_INPUT_WIDTH }}
              marginOverride={margin(0)}
            />
          ),
        }}
      />
      <PatientFormSubheading>
        {
          translations.patientForms.drvGeneralForm.sectionTen
            .pensionOldAgeBenefits
        }
      </PatientFormSubheading>
      <YesNoRadioWithLabel
        elementName="before_retirement_pension_applicable"
        label={
          translations.patientForms.drvGeneralForm.sectionTen.otherBenefits
        }
        sideMutation={(_value, mutate) => {
          mutate(null, "before_retirement_pension");
        }}
        startWithNo
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <TextInputWithLabel
              elementName="before_retirement_pension"
              flatModel
              inputProps={{
                style: { minWidth: SMALL_INPUT_MIN_WIDTH, width: "100%" },
              }}
              label={
                translations.patientForms.drvGeneralForm.sectionTen.benefitsType
              }
              labelWrapperSx={{ width: LARGE_INPUT_WIDTH }}
              marginOverride={margin(0)}
            />
          ),
        }}
      />
      <PatientFormSubheading withBottomPadding>
        {
          translations.patientForms.drvGeneralForm.sectionTen
            .workRelatedAccident
        }
      </PatientFormSubheading>
      <YesNoRadioWithLabel
        elementName="health_damage_present"
        formLabelSx={visuallyHidden}
        label={
          translations.patientForms.drvGeneralForm.sectionTen
            .workRelatedAccident
        }
        sideMutation={(_value, mutate) => {
          mutate(null, "health_damage_origin");
          mutate(null, "health_damage_file_number");
          mutate(null, "health_damages_description");
        }}
        startWithNo
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <VerticalLayout gap={sizing(3)}>
              <HorizontalLayout gap={sizing(3)}>
                <TextInputWithLabel
                  elementName="health_damage_origin"
                  flatModel
                  inputProps={{
                    style: { minWidth: SMALL_INPUT_MIN_WIDTH, width: "100%" },
                  }}
                  label={
                    translations.patientForms.drvGeneralForm.sectionTen
                      .recognisedBy
                  }
                  labelWrapperSx={{ width: LARGE_INPUT_WIDTH }}
                  marginOverride={margin(0)}
                />
                <TextInputWithLabel
                  elementName="health_damage_file_number"
                  flatModel
                  inputProps={{
                    style: { minWidth: SMALL_INPUT_MIN_WIDTH, width: "100%" },
                  }}
                  label={
                    translations.patientForms.drvGeneralForm.sectionTen
                      .fileNumber
                  }
                  labelWrapperSx={{ width: LARGE_INPUT_WIDTH }}
                  marginOverride={margin(0)}
                />
              </HorizontalLayout>
              <TextInputWithLabel
                elementName="health_damages_description"
                flatModel
                label={
                  translations.patientForms.drvGeneralForm.sectionTen
                    .healthIssues
                }
                labelWrapperSx={{ width: "100%" }}
                marginOverride={margin(0)}
              />
            </VerticalLayout>
          ),
        }}
      />
      <YesNoRadioWithLabel
        elementName="application_submitted_applicable"
        label={
          translations.patientForms.drvGeneralForm.sectionTen
            .submittedApplication
        }
        sideMutation={(_value, mutate) => {
          mutate(null, "application_submitted");
        }}
        startWithNo
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <TextInputWithLabel
              elementName="application_submitted"
              flatModel
              inputProps={{
                style: { minWidth: SMALL_INPUT_MIN_WIDTH, width: "100%" },
              }}
              label={
                translations.patientForms.drvGeneralForm.sectionTen
                  .submittedWhere
              }
              labelWrapperSx={{ width: LARGE_INPUT_WIDTH }}
              marginOverride={margin(0)}
            />
          ),
        }}
      />
      <PatientFormSubheading withBottomPadding>
        {translations.patientForms.drvGeneralForm.sectionTen.accidentOrPerson}
      </PatientFormSubheading>
      <YesNoRadioWithLabel
        elementName="risk_of_incapacity_caused_by_accident_third_person"
        formLabelSx={visuallyHidden}
        label={
          translations.patientForms.drvGeneralForm.sectionTen.accidentOrPerson
        }
        startWithNo
      />
      <YesNoRadioWithLabel
        elementName="claim_for_damages_approved"
        label={translations.patientForms.drvGeneralForm.sectionTen.damageClaims}
        sideMutation={(_value, mutate) => {
          mutate(null, "claim_for_damages_origin");
          mutate(null, "claim_for_damages_file_number");
          mutate(null, "claim_for_damages_description");
        }}
        startWithNo
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <VerticalLayout gap={sizing(3)}>
              <HorizontalLayout gap={sizing(3)}>
                <TextInputWithLabel
                  elementName="claim_for_damages_origin"
                  flatModel
                  inputProps={{
                    style: { minWidth: SMALL_INPUT_MIN_WIDTH, width: "100%" },
                  }}
                  label={
                    translations.patientForms.drvGeneralForm.sectionTen
                      .compensationClaims
                  }
                  labelWrapperSx={{ width: LARGE_INPUT_WIDTH }}
                  marginOverride={margin(0)}
                />
                <TextInputWithLabel
                  elementName="claim_for_damages_file_number"
                  flatModel
                  inputProps={{
                    style: { minWidth: SMALL_INPUT_MIN_WIDTH, width: "100%" },
                  }}
                  label={
                    translations.patientForms.drvGeneralForm.sectionTen
                      .fileNumber
                  }
                  labelWrapperSx={{ width: LARGE_INPUT_WIDTH }}
                  marginOverride={margin(0)}
                />
              </HorizontalLayout>
              <DatePickerWithLabel
                elementName="claim_for_damages_description"
                flatModel
                inputSx={{
                  minWidth: SMALL_INPUT_MIN_WIDTH,
                  width: "100%",
                }}
                label={
                  translations.patientForms.drvGeneralForm.sectionTen
                    .compensatedOn
                }
                wrapperSx={{ width: LARGE_INPUT_WIDTH }}
              />
            </VerticalLayout>
          ),
        }}
      />
    </Section>
  );
};
